module.exports = __webpack_public_path__ + "kameon-icons.788d4b059516b3d47a48.ttf";


//////////////////
// WEBPACK FOOTER
// C:/GIT/kameon.gdpr/ui/src/assets/fonts/kameon-icons.ttf?v=0.1.0
// module id = ../../../../../src/assets/fonts/kameon-icons.ttf?v=0.1.0
// module chunks = styles